export default __webpack_public_path__ + "static/media/dino_showroom_paviljonki.e3fe9ab4.jpg";